module.exports = __webpack_public_path__ + "static/media/poorTree.84c15035.svg";